import React from "react";
import "./Team.scss";
import { Container, ProgressBar, Row, Col } from "react-bootstrap";
import Sandaga from "./assets/images/sandaga_home.jpg";
import Mintgif from "./assets/gifs/mint_marauders.gif";
import { MdOutlineCheck } from "react-icons/md";
import { MdOutlineFingerprint } from "react-icons/md";
import { IoPlanetOutline } from "react-icons/io5";


import Bototo from "./assets/images/small_Bototo.png";
import charnouzie_female from "./assets/images/small_charnouzie_female.png";
import charnouzie_male from "./assets/images/small_charnouzie_male.png";
import chibichibi_female from "./assets/images/small_chibichibi_female.png";
import chibichibi_male from "./assets/images/small_chibichibi_male.png";
import froozki_female from "./assets/images/small_froozki_female.png";
import froozki_male from "./assets/images/small_froozkimale.png";
import goonoonoo_female from "./assets/images/small_goonoonoo_female.png";
import goonoonoo_male from "./assets/images/small_goonoonoo_male.png";
import human_female from "./assets/images/small_human_female.png";
import human_male from "./assets/images/small_human_male.png";
import jaboulah_female from "./assets/images/small_jaboulah_female.png";
import jaboulah_male from "./assets/images/small_jaboulah_male.png";
import maltassar_female from "./assets/images/small_maltassar_female.png";
import maltassar_male from "./assets/images/small_maltassar_male.png";
import Nitchy from "./assets/images/small_Nitchy.png";
import pankars_female from "./assets/images/small_pankars_female.png";
import pankars_male from "./assets/images/small_pankars_male.png";
import wongo from "./assets/images/small_wongo.png";
import zorgos from "./assets/images/small_zorgos.png";

import Truck1 from "../../../../assets/images/truck1.gif"
import Truck2 from "../../../../assets/images/truck2.gif"

import Ship1 from "../../../../assets/images/ship1.gif"
import Ship2 from "../../../../assets/images/ship2.gif"

import Planet1 from "../../../../assets/images/planet1.png"
import Planet2 from "../../../../assets/images/planet2.png"
import Planet3 from "../../../../assets/images/planet3.png"
import Planet4 from "../../../../assets/images/planet4.png"
import Planet5 from "../../../../assets/images/planet5.png"
import Planet6 from "../../../../assets/images/planet6.png"

import Astro from "../../../../assets/images/astro.png"

import Alien1 from "../../../../assets/images/alien1.png"

import Astroid2 from "../../../../assets/images/astroid2.png"
import Astroid4 from "../../../../assets/images/astroid4.png"
import Astroid5 from "../../../../assets/images/astroid5.png"
import Astroid6 from "../../../../assets/images/astroid6.png"
import Astroid7 from "../../../../assets/images/astroid7.png"

import { Parallax } from "react-parallax";

const Team = () => {
  const data = [
    {
      id: 1,
      name: "Charnouzie Female",
      planet: "From Gatnatar",
      image: charnouzie_female,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 2,
      name: "Charnouzie Male",
      planet: "From Gatnatar",
      image: charnouzie_male,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 3,
      name: "Bototo",
      planet: "From Artura Z-201",
      image: Bototo,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 4,
      name: "Nitchy",
      planet: "From Dandolo",
      image: Nitchy,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 5,
      name: "Wongo",
      planet: "From Wongodi",
      image: wongo,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 6,
      name: "Human Female",
      planet: "From Earth",
      image: human_female,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 7,
      name: "Human Male",
      planet: "From Earth",
      image: human_male,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 8,
      name: "Zorgos",
      planet: "From Zayzin",
      image: zorgos,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 9,
      name: "Maltassar Female",
      planet: "From Maltass",
      image: maltassar_female,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 10,
      name: "Maltassar male",
      planet: "From Maltass",
      image: maltassar_male,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 11,
      name: "Froozki Female",
      planet: "From Froozkimo",
      image: froozki_female,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 12,
      name: "Froozki male",
      planet: "From Froozkimo",
      image: froozki_male,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 13,
      name: "Chibichibi Female",
      planet: "From Makabala",
      image: chibichibi_female,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 14,
      name: "Chibichibi male",
      planet: "From Makabala",
      image: chibichibi_male,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 15,
      name: "Pankars Female",
      planet: "From Pankora",
      image: pankars_female,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 14,
      name: "Pankars male",
      planet: "From Pankora",
      image: pankars_male,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 15,
      name: "Goonoonoo Female",
      planet: "From Foorara",
      image: goonoonoo_female,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 16,
      name: "Goonoonoo male",
      planet: "From Foorara",
      image: goonoonoo_male,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 17,
      name: "Jaboulah Female",
      planet: "From Malakah",
      image: jaboulah_female,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
    {
      id: 18,
      name: "Jaboulah male",
      planet: "From Malakah",
      image: jaboulah_male,
      iconone: MdOutlineCheck,
      icontwo: IoPlanetOutline,
    },
  ];
  return (
    <>
      <div className="team_section">
        <div className="hero_image">
          <img className="sandaga_home" src={Sandaga} alt="sandaga_home"></img>
        </div>
        <div className="hero_text">
          <h4 className="hero_headind">
            METAVERSE<br></br>MARAUDERS
          </h4>
          <p class="hero_para">Welcome to the Nilmara Galaxy!</p>
        </div>
        <Container>
          <div className="mint_box">
            <Parallax
              renderLayer={(percentage) => {
                let t = percentage * 500
                return (
                  <div className="truck1" style={{ transform: `translateX(${t - 200}%) translateY(${t - 200}%)` }} >
                    <img
                      src={Truck1} alt="ERROR" />
                  </div>
                )
              }}
            >

              <Parallax
                renderLayer={(percentage) => {
                  let t = percentage * 500
                  return (
                    <div className="ship1" style={{ transform: `translateX(${-t + 200}px) translateY(${-t + 200}px)` }} >
                      <img src={Ship1} alt="ERROR" className="ship1" />
                    </div>
                  )
                }}
              >
                <img src={Planet1} alt="ERROR" className="planet1" />
                <img src={Alien1} alt="ERROR" className="alien1" />
                <div className="mint_row">
                  <div className="mint_images">
                    <img
                      className="mint_marauders"
                      src={Mintgif}
                      alt="mint_marauders"
                    ></img>
                  </div>
                  <div className="mint_desc">
                    <h4 className="mint_heading">Mint</h4>
                    <p className="mint_subheading">
                      The Metaverse Marauders “Pack” :
                    </p>
                    <p className="mint_para"></p>
                    <div className="check_row">
                      <MdOutlineCheck
                        className="check_icon"
                        style={{ color: "#30F2AC", fontSize: "32px" }}
                      />
                      <p className="mint_para">
                        Your “classic” Marauders (character + background)
                      </p>
                    </div>
                    <div className="check_row">
                      <MdOutlineCheck
                        className="check_icon"
                        style={{ color: "#30F2AC", fontSize: "32px" }}
                      />
                      <p className="mint_para">
                        Your Marauders with a gradient colored background
                      </p>
                    </div>
                    <div className="check_row">
                      <MdOutlineCheck
                        className="check_icon"
                        style={{ color: "#30F2AC", fontSize: "32px" }}
                      />
                      <p className="mint_para">
                        The background of the classic Marauders (only the
                        background)
                      </p>
                    </div>
                    <div className="check_row">
                      <MdOutlineCheck
                        className="check_icon"
                        style={{ color: "#30F2AC", fontSize: "32px" }}
                      />
                      <p className="mint_para">
                        The Metaverse Marauders Licence of the Marauders
                      </p>
                    </div>
                    <div className="check_row">
                      <MdOutlineCheck
                        className="check_icon"
                        style={{ color: "#30F2AC", fontSize: "32px" }}
                      />
                      <p className="mint_para">
                        NTNFT (non transferable NFT) : A unique non-transferable NFT
                        as a<br></br> reward for all our OG Marauders. MARAUDERS
                        NEVER FORGET.
                      </p>
                    </div>
                    <div className="check_row">
                      <MdOutlineCheck
                        className="check_icon"
                        style={{ color: "#30F2AC", fontSize: "32px" }}
                      />
                      <p className="mint_para">All the utilities included</p>
                      <p className="see_all">
                        <u>See all</u>
                      </p>
                    </div>
                    <div>
                      <h4 className="que_text">How many Packs do you want ?</h4>
                    </div>
                    <div className="eth_count">
                      <button className="dropdown_button">dropdown</button>
                      <div className="eth_div">-ETH</div>
                    </div>
                    <div><button className="mint_button">Mint Stopped</button></div>
                  </div>
                </div>
                <div>
                  <ProgressBar now={20} />
                </div>
                <div className="check_div">
                  <div className="check_line">
                    <p style={{ marginBottom: "0rem" }}>
                      Presale on Arbitrum (ETH L2) • Complete
                    </p>
                    <MdOutlineCheck
                      className="check_icon"
                      style={{ color: "#30F2AC", fontSize: "32px" }}
                    />
                  </div>
                  <div className="check_line">
                    <p style={{ marginBottom: "0rem" }}>
                      1st Presale on ETH L1 • Complete
                    </p>
                    <MdOutlineCheck
                      className="check_icon"
                      style={{ color: "#30F2AC", fontSize: "32px" }}
                    />
                  </div>
                </div>
                <div>
                  <p style={{ color: "#F7B73D" }}>
                    Second spaceship on its way to earth
                  </p>
                </div>
                <div>
                  <h4 className="sale_count"> 1,836 / 12,000 sold</h4>
                </div>
              </Parallax>
            </Parallax>
          </div>

          <div className="rarity_card">
            <Parallax
              renderLayer={(percentage) => {
                let t = percentage * 100
                return (
                  <div className="planet3" style={{ transform: `translateY(${-t + 50}px)` }} >
                    <img src={Planet3} alt="ERROR" />
                  </div>
                )
              }}
            >
              <img src={Astroid2} alt="ERROR" className="asroid2" />
              <img src={Planet2} alt="ERROR" className="planet2" />
              <img src={Planet4} alt="ERROR" className="planet4" />
              <h4 className="rarity_heading">Rarity</h4>
              <Row>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4
                      className="rarity_quantity"
                      style={{ color: "#30F2AC", fontSize: "1.5rem" }}
                    >
                      12K
                    </h4>
                    <p className="rarity_name">Metaverse Marauders</p>
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">20</h4>
                    <p className="rarity_name">Eyes</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">12</h4>
                    <p className="rarity_name">
                      Species (8 gendered & 4 non-gendered)
                    </p>
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">4</h4>
                    <p className="rarity_name">Glasses</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">20</h4>
                    <p className="rarity_name">Shapes (body & colors)</p>
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">7</h4>
                    <p className="rarity_name">Mouths</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">16</h4>
                    <p className="rarity_name">
                      Backgrounds (12 planets & 4 specials)
                    </p>
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">12</h4>
                    <p className="rarity_name">Necklaces</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">14</h4>
                    <p className="rarity_name">Clothes</p>
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">12</h4>
                    <p className="rarity_name">Earrings</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4 className="rarity_quantity">20</h4>
                    <p className="rarity_name">Heads (hair & hats)</p>
                  </div>
                </Col>
                <Col xl={6}>
                  <div className="rarity_desc">
                    <h4
                      className="rarity_quantity"
                      style={{ color: "#FFBE3F", fontSize: "1.5rem" }}
                    >
                      33
                    </h4>
                    <p className="rarity_name">Unique and legendary Marauders</p>
                  </div>
                </Col>
              </Row>
            </Parallax>
          </div>


          <div className="que_div">
            <div className="que_heading">Meet the Marauders</div>
            <div className="que_desc">What’s your favorite species ?</div>
          </div>



          <Parallax
            renderLayer={(percentage) => {
              let t = percentage * 800
              let t2 = percentage * 500
              return (
                <>
                  <div className="card_row">
                    <div className="truck2" style={{ transform: `translateX(${t2 - 380}%) translateY(${t2 - 380}%)` }} >
                      <img src={Truck2} alt="ERROR" />
                    </div>
                    {/* <img src={Truck2} alt="ERROR" className="truck2" /> */}

                    <img src={Astroid4} alt="ERROR" className="astroid4" />
                    <img src={Astroid5} alt="ERROR" className="astroid5" />
                    <img src={Astroid6} alt="ERROR" className="astroid6" />
                    <img src={Astroid7} alt="ERROR" className="astroid7" />

                    {/* <img src={Truck2} alt="ERROR" className="truck2" /> */}

                    <img src={Astro} alt="ERROR" className="astro" />
                    <img src={Planet5} alt="ERROR" className="planet5" />
                    <img src={Planet6} alt="ERROR" className="planet6" />
                    <div className="ship2" style={{ transform: `translateX(${-t + 560}%) translateY(${t - 560}%)` }} >
                      <img src={Ship2} alt="ERROR" />
                    </div>
                    {
                      data.map((data) => {
                        return (
                          <>
                            <div className="character_card">
                              <img
                                className="char_img"
                                src={data.image}
                                alt="character_image"
                              ></img>
                              <div className="name_div">
                                <MdOutlineFingerprint
                                  style={{ color: "#ff3f6d", fontSize: "20px" }}
                                />
                                <p className="character_name">{data.name}</p>
                              </div>
                              <div className="planet_div">
                                <IoPlanetOutline
                                  style={{ color: "#ff3f6d", fontSize: "20px" }}
                                />
                                <p className="planet_from">{data.planet}</p>
                              </div>
                            </div>
                          </>
                        )
                      })
                    }
                  </div>

                </>
              )
            }}
          >


          </Parallax>


        </Container>
      </div>
    </>
  );
};

export default Team;
